export default __webpack_public_path__ + "static/media/LM-bg.98fcc070.svg";